import React, { useContext, useEffect, useState } from "react";
import { Tabs, Tab, Button, Spinner } from "react-bootstrap";
import {
  Bell,
  Mail,
  User,
  Lock,
  Percent,
  ChevronDown,
} from "lucide-react";
import "../../../assets/css/admin/setthing/settingInAdmin.css";
import AdminMasterLayout from "../../../layout/admin/AdminMasterLayout";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

const SettingInAdmin = () => {
  const { baseUrl, loggedInAdmin } = useContext(AppContext);

  // ================= BASIC STATES =================

  const [idToUpdate, setIdToUpdate] = useState("");

  const [key, setKey] = useState("profile");

  // ================= PROFILE STATES =================

  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  // ================= PASSWORD STATES =================

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [updateProfileLoading, setUpdateProfileLoading] = useState(false);
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);

  // ================= NOTIFICATION STATES =================

  const [notificationSettings, setNotificationSettings] = useState({
    appNotification: true,
    emailNotification: false,
  });

  // ================= COMMISSION STATES =================

  const [commissionRate, setCommissionRate] = useState("");
  const [commissionLoading, setCommissionLoading] = useState(false);

  // =========================================================
  // SAVE COMMISSION
  // =========================================================

  const saveCommission = () => {
    setCommissionLoading(true);

    axios
      .post(`${baseUrl}/admin/setting/updateCommission`, {
        id: idToUpdate,
        plateform_commission: commissionRate,
      })
      .then((response) => {
        console.log("Commission Response:", response.data);

        setCommissionLoading(false);

        if (response.data.success) {
          // Database se jo value return hui hai wohi set karo
          setCommissionRate(response.data.plateform_commission);

          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Commission rate updated successfully",
          });
        }
      })
      .catch((error) => {
        console.log("Commission Error:", error.response?.data || error);

        setCommissionLoading(false);

        Swal.fire({
          icon: "error",
          title: "Oops",
          text:
            error.response?.data?.message ||
            "Failed to update commission rate",
        });
      });
  };

  // =========================================================
  // TOGGLE NOTIFICATION
  // =========================================================

  const toggleNotification = (field) => {
    setNotificationSettings((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  // =========================================================
  // VIEW ADMIN PROFILE
  // =========================================================

  const viewAdminProfile = () => {
    axios
      .get(`${baseUrl}/admin/setting/viewAdminprofile`)
      .then((response) => {
        console.log("Admin Profile Response:", response.data);

        const data = response.data.admin;

        if (!data) {
          return;
        }

        // ================= PROFILE =================

        setIdToUpdate(data.id);

        setFullname(data.fullname || "");
        setEmail(data.email || "");
        setPhone(data.phone || "");

        // ================= NOTIFICATIONS =================

        setNotificationSettings({
          appNotification: data.app_notification === 1,
          emailNotification: data.email_notification === 1,
        });

        // ================= COMMISSION =================

        setCommissionRate(data.plateform_commission ?? 10);
      })
      .catch((error) => {
        console.log(
          "Admin Profile Error:",
          error.response?.data || error
        );
      });
  };

  // =========================================================
  // UPDATE PROFILE
  // =========================================================

  const updateProfile = () => {
    console.log(
      "log from the update profile function",
      idToUpdate,
      fullname,
      email,
      phone,
      currentPassword,
      newPassword
    );

    if (newPassword && newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Oops",
        text: "Password not matched",
      });

      return;
    }

    setUpdateProfileLoading(true);

    const formData = new FormData();

    formData.append("id", idToUpdate);
    formData.append("fullname", fullname);
    formData.append("phone", phone);

    // Password fields
    // formData.append("current_password", currentPassword);
    // formData.append("new_password", newPassword);
    // formData.append("confirm_password", confirmPassword);

    axios
      .post(`${baseUrl}/admin/setting/updateProfile`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("log from the response data", res.data);

        setUpdateProfileLoading(false);

        viewAdminProfile();

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Profile updated successfully",
        });
      })
      .catch((error) => {
        console.log(error.response?.data);

        setUpdateProfileLoading(false);

        Swal.fire({
          icon: "error",
          title: "Oops",
          text:
            error.response?.data?.message ||
            "Failed to update profile",
        });
      });
  };

  // =========================================================
  // CHANGE PASSWORD
  // =========================================================

  const changePassword = () => {
    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Oops",
        text: "Password not matched",
      });

      return;
    }

    setChangePasswordLoading(true);

    const formData = new FormData();

    formData.append("id", idToUpdate);
    formData.append("current_password", currentPassword);
    formData.append("new_password", newPassword);
    formData.append("confirm_password", confirmPassword);

    axios
      .post(`${baseUrl}/admin/setting/changePassword`, formData)
      .then((res) => {
        setChangePasswordLoading(false);

        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");

        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data.message,
        });
      })
      .catch((error) => {
        console.log(error.response?.data);

        setChangePasswordLoading(false);

        Swal.fire({
          icon: "error",
          title: "Oops",
          text:
            error.response?.data?.message ||
            "Failed to change password",
        });
      });
  };

  // =========================================================
  // RESET FORM
  // =========================================================

  const resetForm = () => {
    setFullname("");
    setEmail("");
    setPhone("");
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setIdToUpdate("");
  };

  // =========================================================
  // USE EFFECT
  // =========================================================

  useEffect(() => {
    console.log(
      "useEffect called from the profile screen",
      loggedInAdmin
    );

    viewAdminProfile();

    if (loggedInAdmin) {
      setFullname(loggedInAdmin.fullname || "");
      setEmail(loggedInAdmin.email || "");
      setPhone(loggedInAdmin.phone || "");
    }
  }, []);

  // =========================================================
  // RETURN
  // =========================================================

  return (
    <AdminMasterLayout>
      <div className="settings-wrapper">
        <Tabs
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="settings-tabs"
        >

          {/* =====================================================
              PROFILE TAB
          ====================================================== */}

          <Tab
            eventKey="profile"
            title={
              <span className="tab-title">
                <User size={16} /> Profile
              </span>
            }
          >
            <div className="settings-card">
              <h5>Profile Information</h5>

              <div className="settings-grid">

                <input
                  type="text"
                  placeholder="Full Name"
                  value={fullname}
                  onChange={(e) => setFullname(e.target.value)}
                />

                <input
                  type="email"
                  placeholder="Email Address"
                  disabled={true}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <input
                  type="number"
                  placeholder="Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />

              </div>

              <div className="text-end mt-4">
                <Button
                  onClick={updateProfile}
                  disabled={updateProfileLoading}
                >
                  {updateProfileLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Update Profile"
                  )}
                </Button>
              </div>
            </div>
          </Tab>

          {/* =====================================================
              PASSWORD TAB
          ====================================================== */}

          <Tab
            eventKey="password"
            title={
              <span className="tab-title">
                <Lock size={16} /> Password
              </span>
            }
          >
            <div className="settings-card">
              <h5>Reset Password</h5>

              <div className="settings-grid">

                <input
                  type="password"
                  placeholder="Current Password"
                  value={currentPassword}
                  onChange={(e) =>
                    setCurrentPassword(e.target.value)
                  }
                />

                <input
                  type="password"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(e) =>
                    setNewPassword(e.target.value)
                  }
                />

                <input
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) =>
                    setConfirmPassword(e.target.value)
                  }
                />

              </div>

              <div className="text-end mt-4">
                <Button
                  variant="danger"
                  onClick={changePassword}
                  disabled={changePasswordLoading}
                >
                  {changePasswordLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Reset Password"
                  )}
                </Button>
              </div>
            </div>
          </Tab>

          {/* =====================================================
              NOTIFICATIONS TAB
          ====================================================== */}

          <Tab
            eventKey="notifications"
            title={
              <span className="tab-title">
                <Bell size={16} /> Notifications
              </span>
            }
          >
            <div className="settings-card">
              <h5>Notification Settings</h5>

              <div className="settings-row">

                <div className="setting-info">
                  <Bell size={18} />
                  <span>App Notification</span>
                </div>

                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={
                      notificationSettings.appNotification
                    }
                    onChange={() =>
                      toggleNotification("appNotification")
                    }
                  />

                  <span className="toggle-slider"></span>
                </label>

              </div>

              <div className="settings-row">

                <div className="setting-info">
                  <Mail size={18} />
                  <span>Email Notification</span>
                </div>

                <label className="toggle-switch">

                  <input
                    type="checkbox"
                    checked={
                      notificationSettings.emailNotification
                    }
                    onChange={() =>
                      toggleNotification("emailNotification")
                    }
                  />

                  <span className="toggle-slider"></span>

                </label>

              </div>
            </div>
          </Tab>

          {/* =====================================================
              COMMISSION TAB
          ====================================================== */}

          <Tab
            eventKey="commission"
            title={
              <span className="tab-title">
                <Percent size={16} /> Commission
              </span>
            }
          >
            <div className="settings-card">

              {/* ================= COMMISSION HEADER ================= */}

              <div className="commission-accordion-header">

                <div className="commission-header-left">

                  <div className="commission-icon-box">
                    <Percent
                      size={20}
                      color="#16a34a"
                    />
                  </div>

                  <div>

                    <h6 className="commission-title">
                      Commission
                    </h6>

                    <p className="commission-subtitle">
                      Platform commission rate applied on
                      completed seller orders
                    </p>

                  </div>

                </div>

                <ChevronDown
                  size={18}
                  className="commission-chevron"
                />

              </div>

              <hr className="commission-divider" />

              {/* ================= COMMISSION FORM ================= */}

              <div className="commission-body">

                <label className="commission-label">
                  Commission Rate (%)
                </label>

                <input
                  type="number"
                  className="commission-input"
                  value={commissionRate}
                  onChange={(e) =>
                    setCommissionRate(e.target.value)
                  }
                  placeholder="10"
                />

                <p className="commission-hint">
                  This percentage is deducted from each
                  completed seller order.
                  <br />
                  Sellers see it on their order details and
                  wallet earnings.
                </p>

                <button
                  type="button"
                  className="commission-save-btn"
                  onClick={saveCommission}
                  disabled={commissionLoading}
                >
                  {commissionLoading ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        className="me-2"
                      />
                      Saving...
                    </>
                  ) : (
                    "Save Commission Rate"
                  )}
                </button>

              </div>
            </div>
          </Tab>

        </Tabs>
      </div>
    </AdminMasterLayout>
  );
};

export default SettingInAdmin;